import type { LensPeriod } from '@/Network/Types/Requests/DashboardSavedViewRequests'

/**
 * Celular v3 (SPEC-v3 Q8): Semana e Mês viram a aba "Escala", que sempre carrega o mês
 * (a S1 mostra a semana pela fita). 'semana' vira 'mes'; os outros períodos ficam.
 */
export function resolveMobileV3Period(period: LensPeriod): LensPeriod {
  return period === 'semana' ? 'mes' : period
}
